export const categories = [
  {
    id: 'cat-basics',
    name: '基础入门',
    icon: 'ri-book-open-line',
    description: '从零开始了解 17c 平台的基础知识和核心概念',
    count: 12,
  },
  {
    id: 'cat-features',
    name: '功能详解',
    icon: 'ri-tools-line',
    description: '深入了解 17c 各项功能的详细操作指南和使用技巧',
    count: 18,
  },
  {
    id: 'cat-advanced',
    name: '进阶技巧',
    icon: 'ri-rocket-2-line',
    description: '掌握高级用法和效率提升技巧，成为 17c 高级用户',
    count: 10,
  },
  {
    id: 'cat-cases',
    name: '实战案例',
    icon: 'ri-file-list-3-line',
    description: '真实用户案例分享，了解 17c 在各行业的应用场景',
    count: 15,
  },
  {
    id: 'cat-updates',
    name: '更新动态',
    icon: 'ri-notification-3-line',
    description: '获取 17c 最新版本更新、新功能发布和平台动态',
    count: 8,
  },
  {
    id: 'cat-faq',
    name: '常见问题',
    icon: 'ri-question-answer-line',
    description: '汇总用户常见问题和解决方案，快速找到您需要的答案',
    count: 20,
  },
];

export const categoryArticles: Record<string, {
  id: string;
  title: string;
  summary: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}[]> = {
  'cat-basics': [
    {
      id: 'article-1',
      title: '17c 平台快速上手指南',
      summary: '本文将带您快速了解 17c 平台的基本操作流程，从注册到完成第一个任务，让您在十分钟内掌握核心用法。',
      date: '2026-08-10',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20laptop%20displaying%20clean%20dashboard%20interface%2C%20warm%20ambient%20lighting%2C%20organized%20desk%20setup%2C%20professional%20environment%2C%20soft%20neutral%20tones&width=600&height=400&seq=cat-basics-01&orientation=landscape',
      tags: ['入门', '教程', '新手'],
    },
    {
      id: 'article-2',
      title: '账号注册与安全设置',
      summary: '详细讲解 17c 账号的注册流程、安全设置建议，以及如何保护您的账户信息安全。',
      date: '2026-08-08',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20secure%20login%20screen%20interface%20on%20clean%20minimal%20desk%2C%20soft%20natural%20light%2C%20warm%20neutral%20background%2C%20professional%20product%20photography&width=600&height=400&seq=cat-basics-02&orientation=landscape',
      tags: ['注册', '安全', '设置'],
    },
    {
      id: 'article-3',
      title: '17c 界面导览与操作说明',
      summary: '全面介绍 17c 平台的操作界面，包括导航栏、功能面板、设置中心等核心区域的详细说明。',
      date: '2026-08-05',
      readTime: '10分钟',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20web%20application%20interface%20with%20navigation%20sidebar%20and%20dashboard%20widgets%2C%20minimal%20design%2C%20warm%20color%20palette%2C%20professional%20UI%20mockup%2C%20soft%20shadows&width=600&height=400&seq=cat-basics-03&orientation=landscape',
      tags: ['界面', '导航', '操作'],
    },
  ],
  'cat-features': [
    {
      id: 'article-4',
      title: '数据管理功能深度解析',
      summary: '深入了解 17c 的数据管理功能，包括数据导入导出、分类整理、批量操作等核心能力。',
      date: '2026-08-09',
      readTime: '12分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20data%20analytics%20dashboard%20displaying%20charts%20and%20graphs%20on%20large%20monitor%2C%20clean%20minimal%20workspace%2C%20warm%20lighting%2C%20professional%20setting%2C%20soft%20neutral%20background&width=600&height=400&seq=cat-features-01&orientation=landscape',
      tags: ['数据', '管理', '功能'],
    },
    {
      id: 'article-5',
      title: '协同办公与团队协作',
      summary: '了解 17c 的团队协作功能，学习如何高效地与团队成员共享信息、分配任务和追踪进度。',
      date: '2026-08-07',
      readTime: '9分钟',
      image: 'https://readdy.ai/api/search-image?query=Team%20collaboration%20workspace%20with%20multiple%20screens%20showing%20project%20management%20tools%2C%20modern%20office%20setting%2C%20warm%20ambient%20light%2C%20professional%20environment&width=600&height=400&seq=cat-features-02&orientation=landscape',
      tags: ['协作', '团队', '共享'],
    },
    {
      id: 'article-6',
      title: '智能提醒与任务管理',
      summary: '掌握 17c 的智能提醒系统，学会设置个性化提醒规则，让重要事项不再遗漏。',
      date: '2026-08-03',
      readTime: '7分钟',
      image: 'https://readdy.ai/api/search-image?query=Digital%20task%20management%20board%20with%20sticky%20notes%20and%20checklists%20on%20tablet%20device%2C%20clean%20minimal%20desk%2C%20warm%20lighting%2C%20organized%20productivity%20scene&width=600&height=400&seq=cat-features-03&orientation=landscape',
      tags: ['提醒', '任务', '管理'],
    },
  ],
  'cat-advanced': [
    {
      id: 'article-7',
      title: 'API 接口调用完全指南',
      summary: '面向开发者的 17c API 接口文档，包含详细的调用示例、参数说明和最佳实践。',
      date: '2026-08-06',
      readTime: '15分钟',
      image: 'https://readdy.ai/api/search-image?query=Code%20editor%20displaying%20API%20documentation%20on%20computer%20screen%2C%20dark%20theme%20IDE%2C%20modern%20developer%20workspace%2C%20warm%20ambient%20lighting%2C%20minimal%20setup&width=600&height=400&seq=cat-advanced-01&orientation=landscape',
      tags: ['API', '开发', '接口'],
    },
    {
      id: 'article-8',
      title: '自动化工作流配置技巧',
      summary: '学习如何利用 17c 的自动化功能创建高效工作流，减少重复操作，提升整体效率。',
      date: '2026-08-02',
      readTime: '11分钟',
      image: 'https://readdy.ai/api/search-image?query=Automation%20workflow%20diagram%20visualization%20on%20modern%20screen%2C%20minimal%20design%2C%20clean%20lines%20and%20nodes%2C%20warm%20neutral%20color%20scheme%2C%20professional%20dashboard&width=600&height=400&seq=cat-advanced-02&orientation=landscape',
      tags: ['自动化', '工作流', '效率'],
    },
  ],
  'cat-cases': [
    {
      id: 'article-9',
      title: '电商团队如何利用 17c 提升运营效率',
      summary: '某电商团队通过 17c 平台实现了运营流程的全面优化，订单处理时间缩短了60%，客户满意度显著提升。',
      date: '2026-08-04',
      readTime: '10分钟',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20team%20working%20in%20modern%20office%20with%20computers%20displaying%20sales%20dashboards%2C%20collaborative%20atmosphere%2C%20warm%20lighting%2C%20professional%20setting&width=600&height=400&seq=cat-cases-01&orientation=landscape',
      tags: ['电商', '案例', '效率'],
    },
    {
      id: 'article-10',
      title: '创业公司从零到一的 17c 实践之路',
      summary: '一家初创公司分享了他们如何借助 17c 平台在六个月内实现业务流程的数字化转型和快速增长。',
      date: '2026-07-28',
      readTime: '13分钟',
      image: 'https://readdy.ai/api/search-image?query=Startup%20team%20brainstorming%20in%20bright%20modern%20office%20with%20sticky%20notes%20and%20whiteboard%2C%20creative%20atmosphere%2C%20warm%20natural%20light%2C%20energetic%20environment&width=600&height=400&seq=cat-cases-02&orientation=landscape',
      tags: ['创业', '案例', '数字化'],
    },
  ],
  'cat-updates': [
    {
      id: 'article-11',
      title: '17c V3.2 版本更新公告',
      summary: '全新的界面设计、更强大的数据分析工具以及多项性能优化，17c V3.2 为您带来焕然一新的使用体验。',
      date: '2026-08-01',
      readTime: '5分钟',
      image: 'https://readdy.ai/api/search-image?query=Modern%20software%20update%20announcement%20screen%20with%20version%20number%20and%20new%20features%20list%2C%20clean%20minimal%20design%2C%20warm%20gradient%20background%2C%20professional%20UI&width=600&height=400&seq=cat-updates-01&orientation=landscape',
      tags: ['更新', '版本', '新功能'],
    },
    {
      id: 'article-12',
      title: '2026年第三季度产品路线图',
      summary: '了解 17c 未来三个月的发展规划，包括即将推出的新功能和优化改进方向。',
      date: '2026-07-25',
      readTime: '8分钟',
      image: 'https://readdy.ai/api/search-image?query=Product%20roadmap%20timeline%20visualization%20on%20modern%20display%2C%20clean%20minimal%20design%2C%20milestone%20markers%2C%20warm%20neutral%20color%20palette%2C%20professional%20presentation&width=600&height=400&seq=cat-updates-02&orientation=landscape',
      tags: ['路线图', '规划', '预告'],
    },
  ],
  'cat-faq': [
    {
      id: 'article-13',
      title: '17c 平台常见问题汇总',
      summary: '整理了用户最常询问的问题，涵盖账号、功能、付费、安全等各个方面，帮助您快速找到答案。',
      date: '2026-08-11',
      readTime: '14分钟',
      image: 'https://readdy.ai/api/search-image?query=FAQ%20help%20center%20webpage%20with%20question%20and%20answer%20cards%2C%20clean%20minimal%20design%2C%20organized%20layout%2C%20warm%20neutral%20tones%2C%20professional%20support%20page&width=600&height=400&seq=cat-faq-01&orientation=landscape',
      tags: ['FAQ', '问答', '帮助'],
    },
    {
      id: 'article-14',
      title: '如何解决登录异常问题',
      summary: '当遇到无法登录、密码错误或验证失败等情况时，请参考本文提供的排查步骤解决登录问题。',
      date: '2026-07-30',
      readTime: '6分钟',
      image: 'https://readdy.ai/api/search-image?query=Troubleshooting%20guide%20on%20laptop%20screen%20with%20step%20by%20step%20instructions%2C%20clean%20minimal%20design%2C%20warm%20lighting%2C%20helpful%20support%20theme&width=600&height=400&seq=cat-faq-02&orientation=landscape',
      tags: ['登录', '问题', '排查'],
    },
  ],
};